// Campaign types
// Disposition system codes that are always present
export const DISPOSITION_CONFIG = {
    'A': { description: 'Answering machine detected: Callee asked to press a digit, leave a message or gave another message from an answering machine.', canCallback: true, isEditable: true, isDeletable: false },
    'AA': { description: 'Dial - answering machine detected by AMD', canCallback: true, isEditable: false, isDeletable: false },
    'AB': { description: 'Dial - busy', canCallback: true, isEditable: false, isDeletable: false },
    'DAIR': { description: 'Dead air - no customer speech', canCallback: true, isEditable: false, isDeletable: false },
    'DF': { description: 'Dial - failed', canCallback: true, isEditable: false, isDeletable: false },
    'DNC': { description: 'Customer asked to be added to a do-not-call list', canCallback: false, isEditable: true, isDeletable: false },
    'HU': { description: 'Customer hung up quickly', canCallback: true, isEditable: true, isDeletable: false },
    'NA': { description: 'Dial - no answer', canCallback: true, isEditable: false, isDeletable: false },
    'NEW': { description: 'New lead', canCallback: true, isEditable: false, isDeletable: false },
    'SUCCESS': { description: 'Successful call (transfer / tool called)', canCallback: true, isEditable: true, isDeletable: false },
};
export const REQUIRED_DISPOSITIONS = Object.entries(DISPOSITION_CONFIG).map(([code, config]) => ({
    code,
    description: config.description,
    canCallback: config.canCallback,
    isEditable: config.isEditable,
    isDeletable: config.isDeletable,
}));
export const DEFAULT_CUSTOM_DISPOSITIONS = [
    { code: 'CALLBK', description: 'The callee asked to call them back later AND call is longer than 30 seconds', canCallback: true, isEditable: true, isDeletable: true },
    { code: 'HL', description: 'Hot lead. The callee was interested in the offer, but the call was not successful AND the call is longer than 30 seconds', canCallback: true, isEditable: true, isDeletable: true },
    { code: 'NI', description: 'The callee was not interested in the offer', canCallback: false, isEditable: true, isDeletable: true },
    { code: 'NQ', description: 'The callee was not qualified for the offer (e.g. offer was loan restructuring, but callee doesn\'t have any debt)', canCallback: false, isEditable: true, isDeletable: true },
    { code: 'WN', description: 'Wrong number. The callee said that the agent is calling the wrong number', canCallback: false, isEditable: true, isDeletable: true },
];
// Helper to get uneditable disposition codes
export function getUneditableDispositionCodes() {
    return Object.entries(DISPOSITION_CONFIG)
        .filter(([, config]) => !config.isEditable)
        .map(([code]) => code);
}
// Helper to convert UI metrics to backend format
export function metricsToBackendConfig(metrics) {
    return metrics.map((metric) => {
        // Map filter to backend filter class
        let filterCls = 'AllCallsFilter';
        let filterKwargs = {};
        if (metric.filter === 'successful_calls') {
            filterCls = 'SuccessfulCallsFilter';
        }
        else if (metric.filter === 'over_30_seconds') {
            filterCls = 'DurationFilter';
            filterKwargs = { min_duration: 30 };
        }
        // Map type to backend metric class
        let metricCls;
        let metricKwargs;
        if (metric.type === 'includes_phrase') {
            metricCls = 'IncludesPhraseMetric';
            metricKwargs = {
                name: metric.name,
                phrases: metric.config.phrases || '',
                case_sensitive: false,
            };
        }
        else {
            metricCls = 'LLMEvalMetric';
            metricKwargs = {
                name: metric.name,
                prompt: metric.config.prompt || '',
            };
        }
        return {
            name: metric.name,
            cls: 'ConditionalMetric',
            kwargs: {
                name: metric.name,
                filter_cls: filterCls,
                filter_kwargs: filterKwargs,
                metric_cls: metricCls,
                metric_kwargs: metricKwargs,
            },
        };
    });
}
